import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { FullTable, MinLoader } from 'components';
import { Colors, FindLoad, FindSuccessItem, Images, sortListByKey } from 'utils';
import { httpRequestsOnSuccessActions, resourceActions } from 'store';
import { ACCESS_ACTION_TYPE, accessBody, accessHead } from './constants';

const ACTION_TYPE = 'EDIT_RESOURCE_ACCESS';
export const Access = () => {
    const resourceList = useSelector((state) => state.resource.resourceList);
    const resourceAccessList = useSelector((state) => state.resource.resourceAccessList);
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const loading = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const [disabled, setDisabled] = useState(true);
    const [selectedList, setSelectedList] = useState({
        upload: [],
        download: [],
        delete: [],
    });

    const resetByDefault = () => {
        const initialSelection = {
            upload: resourceAccessList.filter((staff) => staff.upload).map((staff) => staff.staffId),
            download: resourceAccessList.filter((staff) => staff.download).map((staff) => staff.staffId),
            delete: resourceAccessList.filter((staff) => staff.delete).map((staff) => staff.staffId),
        };
        setSelectedList(initialSelection);
    };

    useEffect(() => {
        if (resourceAccessList) {
            resetByDefault();
        }
    }, [resourceAccessList]);

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            setDisabled(true);
        }
    }, [success]);

    useEffect(() => {
        dispatch(resourceActions.getResourceAccess(params?.id));
    }, []);

    const handleCheck = (item, permissionType, selectType) => {
        setSelectedList((prev) => {
            let updated = { ...prev };

            if (selectType === 'all') {
                const allSelected = resourceAccessList.every((staff) => prev[permissionType].includes(staff.staffId));
                updated[permissionType] = allSelected
                    ? [] // uncheck all
                    : resourceAccessList.map((staff) => staff.staffId); // check all
            } else {
                const alreadySelected = prev[permissionType].includes(item.staffId);
                updated[permissionType] = alreadySelected
                    ? prev[permissionType].filter((id) => id !== item.staffId)
                    : [...prev[permissionType], item.staffId];
            }

            return updated;
        });
    };

    const generatePayload = () => {
        const changedStaffAccesses = resourceAccessList
            .map((staff) => {
                const staffId = staff.staffId;
                const original = {
                    upload: !!staff.upload,
                    download: !!staff.download,
                    delete: !!staff.delete,
                };
                const current = {
                    upload: selectedList.upload.includes(staffId),
                    download: selectedList.download.includes(staffId),
                    delete: selectedList.delete.includes(staffId),
                };
                const hasChanged =
                    original.upload !== current.upload || original.download !== current.download || original.delete !== current.delete;

                return hasChanged ? { id: staff?.id, staffId, ...current } : null;
            })
            .filter(Boolean);

        if (changedStaffAccesses.length === 0) return;

        const res = {
            staffAccesses: changedStaffAccesses,
        };

        dispatch(resourceActions.editResourceAccess(params?.id, res));
    };
    // const generatePayload = () => {
    //     const res = {
    //         staffAccesses: resourceAccessList.map(staff => ({
    //             staffId: staff.staffId,
    //             upload: selectedList.upload.includes(staff.staffId),
    //             download: selectedList.download.includes(staff.staffId),
    //             delete: selectedList.delete.includes(staff.staffId),
    //         })),
    //     };
    //     dispatch(resourceActions.editResourceAccess(params?.id, res))
    // };

    return (
        <div className="access-table-wrapper">
            <div className="flex-end" style={{ margin: '-10px 0 16px 0', height: 23 }}>
                {disabled ? (
                    <button onClick={() => setDisabled(false)} className="reset-btn-by-default edit-access-btn">
                        <img src={Images.edit} alt="edit" />
                        <p>Edit Access</p>
                    </button>
                ) : (
                    <div className="flex-align-center" style={{ gap: 24 }}>
                        <button
                            className="reset-btn-by-default cancel-access-btn"
                            onClick={() => {
                                setDisabled(true);
                                resetByDefault();
                            }}
                        >
                            Cancel
                        </button>
                        <button onClick={generatePayload} className="reset-btn-by-default edit-access-btn" style={{ width: '100px' }}>
                            {loading?.length ? (
                                <MinLoader margin={'0'} width={'14px'} height={'14px'} color={Colors.ThemeBlue} position={'relative'} />
                            ) : (
                                <p>Save Changes</p>
                            )}
                        </button>
                    </div>
                )}
            </div>
            <FullTable
                head={accessHead(handleCheck, resourceAccessList, selectedList, disabled)}
                body={accessBody(handleCheck, selectedList, disabled)}
                loadingType={ACCESS_ACTION_TYPE}
                list={sortListByKey(resourceAccessList, 'staffFullName', info)}
                noText={'Accesses'}
                activeRowId={''}
                margin={'0'}
            />
        </div>
    );
};
